import {ListView} from '@github-ui/list-view'
import {ListViewMetadata} from '@github-ui/list-view/ListViewMetadata'
import {Spinner} from '@primer/react'
import {SkeletonBox} from '@primer/react/experimental'
import {useMemo} from 'react'

import styles from './RepositoryViews.module.css'
import type {SavedView} from './types'
import {ViewRow} from './ViewRow'
import type {ViewsSortValue} from './views-sort-options'
import {ViewsSortMenu} from './ViewsSortMenu'

type ViewsListProps = {
  views: SavedView[]
  owner: string
  repo: string
  sort: ViewsSortValue
  onSortChange: (value: ViewsSortValue) => void
  isLoading?: boolean
}

export function ViewsList({views, owner, repo, sort, onSortChange, isLoading = false}: ViewsListProps) {
  const actions = useMemo(
    () => [
      {
        key: 'views-sort-menu',
        render: () => <ViewsSortMenu sort={sort} onSortChange={onSortChange} />,
      },
    ],
    [sort, onSortChange],
  )

  const itemCount = isLoading ? (
    <SkeletonBox height="1em" width="60px" />
  ) : (
    `${views.length} ${views.length === 1 ? 'item' : 'items'}`
  )
  const metadata = <ListViewMetadata title={itemCount} actions={actions} actionsLabel="Actions" />

  return (
    <ListView title="Saved views" metadata={metadata} titleHeaderTag="h2" as="ul" role="list">
      {isLoading ? (
        <li className={styles.loadingContainer} role="presentation">
          <Spinner size="large" />
        </li>
      ) : (
        views.map(view => <ViewRow key={view.id} view={view} owner={owner} repo={repo} />)
      )}
    </ListView>
  )
}
